import { Stack, Typography } from "@mui/material";
import DialogAnimate from "src/components/animate/DialogAnimate";
import useLocales from "src/hooks/useLocales";

import Context from "./context";
import RevokeSecretForm from "./RevokeSecretForm";

type Props = {
	show: boolean;
	onClose: () => void;
};

export default function RevokeSecretDialog({ show, onClose }: Props) {
	const { translate } = useLocales();

	return (
		<DialogAnimate maxWidth={"xs"} onClose={onClose} open={show}>
			<Stack sx={{ p: 3, pb: 0 }} gap={1}>
				<Typography variant='subtitle1' fontSize={21}>
					{translate("app_secrets.confirm_password")}
				</Typography>
				<Typography variant='subtitle1' fontSize={12} color='text.secondary'>
					{translate("app_secrets.confirm_password_des")}
				</Typography>
			</Stack>
			<Context.Provider value={{ onClose }}>
				<RevokeSecretForm />
			</Context.Provider>
		</DialogAnimate>
	);
}
